module.exports = __webpack_public_path__ + "static/media/person3.b65ae406.svg";